/**
 * @typedef {import('../MapLibreMap.js').MLD} MLD
 */


/**
 * @typedef {Object} IMapBoundsOverlayItem
 * @property {MLD._LngLatBounds} bounds
 * @property {MLD._LngLat[]=} additionalPoints
 * @property {boolean=} showBoundsCenter
 * @property {boolean=} showCameraCenter
 * @property {string=} fillColor
 */

window.OSM = window.OSM ?? {};
window.OSM.boundsOverlayIndex = 0;
OSM.MapBoundsOverlay = class MapBoundsOverlay {


    /** @type {OSM.MapLibreMap} */
    map;
    /** @type {IMapBoundsOverlayItem[]} */
    itemList;

    layerIDs = [];


    /**
     *
     * @param {OSM.MapLibreMap} map
     * @param {IMapBoundsOverlayItem[]} itemList
     */
    constructor(map, itemList) {
        this.map = map;
        this.itemList = Array.isArray(itemList) ? itemList : [itemList];
        this.initialize();
    }

    initialize(){

        const map = this.map.map;
        const locationManager = OSM.manager.getLocationManager();
        const overlayIndex = window.OSM.boundsOverlayIndex;
        window.OSM.boundsOverlayIndex ++;
        for(let i= 0; i < this.itemList.length; i++) {
            const item = this.itemList[i];

            const bounds = item.bounds;

            const center = locationManager.getBoundsCenter(bounds);
            const cameraCenter = this.map.getCameraCenterForBounds(bounds);
            let layerID = "boundsOverlayRectangle"+overlayIndex+"_"+i;
            this.layerIDs.push(layerID);

            let north = bounds.getNorth();
            let south = bounds.getSouth();
            let east = bounds.getEast();
            let west = bounds.getWest();


            const northSouth = locationManager.normalisedNorthSouth(north, south);
            const eastWest = locationManager.normalisedEastWest(east, west);

            north = northSouth.north;
            south = northSouth.south;
            east = eastWest.east;
            west = eastWest.west;
            if(east < west) {
                east += 360;
            }

            let coordinates = [
                [west, north],
                [west, south],
                [east, south],
                [east, north],
                [west, north]
            ];
            map.addSource(layerID, {
                type: 'geojson',
                data: {
                    type: 'Feature',
                    properties: {},
                    geometry: {
                        type: 'Polygon',
                        coordinates: [
                            coordinates
                        ]
                    }
                }
            });
            map.addLayer({
                id: layerID,
                type: 'fill',
                source: layerID,
                layout: {},
                paint: {
                    "fill-color": item.fillColor ? item.fillColor : '#088',
                    'fill-opacity': 0.3
                }
            });

            /** @type {{lngLat:MLD._LngLat, color:string, excludeHorizontal:boolean=, excludeVertical:boolean=}[]} */
            const innerLineItems = [ ];
            if(item.showBoundsCenter){
                innerLineItems.push({
                    lngLat: center,
                    color: "#888"
                })
            }
            if(item.showCameraCenter){
                innerLineItems.push({
                    lngLat: cameraCenter,
                    color: "#1d5380",
                    excludeVertical: true
                })
            }

            const additionalPoints = item.additionalPoints ?? [];
            for(let additionalPoint of additionalPoints) {
                innerLineItems.push({
                    lngLat: additionalPoint,
                    color: "#da1717"
                })
            }

            for(let j = 0; j < innerLineItems.length; j++) {
                const lineItem = innerLineItems[j];
                if(!lineItem.excludeHorizontal) {

                    layerID = "boundsOverlayHorizontalLine"+overlayIndex+"_"+i+"_"+j;
                    this.layerIDs.push(layerID);

                    coordinates = [
                        [west, lineItem.lngLat.lat],
                        [east, lineItem.lngLat.lat]
                    ];

                    map.addSource(layerID, {
                        type: 'geojson',
                        data: {
                            type: 'Feature',
                            properties: {},
                            geometry: {
                                type: 'LineString',
                                coordinates: coordinates
                            }
                        }
                    });
                    map.addLayer({
                        id: layerID,
                        type: 'line',
                        source: layerID,
                        layout: {
                            'line-join': 'round',
                            'line-cap': 'round'
                        },
                        paint: {
                            'line-color': lineItem.color,
                            'line-width': 1
                        }
                    });

                }
                if(!lineItem.excludeVertical) {
                    layerID = "boundsOverlayVerticalLine"+overlayIndex+"_"+i+"_"+j;
                    this.layerIDs.push(layerID);

                    coordinates = [
                        [lineItem.lngLat.lng, north],
                        [lineItem.lngLat.lng, south]
                    ];

                    map.addSource(layerID, {
                        type: 'geojson',
                        data: {
                            type: 'Feature',
                            properties: {},
                            geometry: {
                                type: 'LineString',
                                coordinates: coordinates
                            }
                        }
                    });
                    map.addLayer({
                        id: layerID,
                        type: 'line',
                        source: layerID,
                        layout: {
                            'line-join': 'round',
                            'line-cap': 'round'
                        },
                        paint: {
                            'line-color': lineItem.color,
                            'line-width': 1
                        }
                    });
                }
            }
        }
    }

    removeFromMap(){
        for(let layerID of this.layerIDs){
            this.map.map.removeLayer(layerID)
            this.map.map.removeSource(layerID)
        }
    }

}